export default class Theme {
	/**
	 Constructor
	 **/
	constructor() {
		this.build();
	}

	/**
	 Build page elements, plugins init
	 **/
	build() {
		this.bgImage();
		this.sliderFpAuctions();
		this.sliderFpDelivery();
		this.sliderFpCarAdvantages();
		this.scrollTop();
	}

	bgImage() {
		// background image
		const bgElements = document.querySelectorAll('[data-bg-image]');

		for (const el of bgElements) {
			const image = el.getAttribute('data-bg-image');
			if (image) {
				el.style.backgroundImage = `url("${image}")`;
			}
		}
	}

	sliderFpAuctions() {
		const sliderEl = document.querySelector('#fp-auctions-slider');
		if (!sliderEl) return;

		var splide = new Splide(sliderEl, {
			type: 'loop',
			// perPage: 7,
			// perMove: 1,
			autoWidth: true,
			focus: 'center',
			speed: 2000,
			gap: 20,
			arrows: false,
			pagination: false,
			//easing: 'cubic-bezier(0.42, 0, 0.58, 1)', // The "Slow-Fast-Slow" curve
			autoplay: 'pause', // Start in a paused state
			interval: 4000,
			reducedMotion: {
				speed: 2000,
				autoplay: true,
			},

			breakpoints: {
				// 	1440: {},
				// 	1280: {},
				1023: {
					gap: 10,
				},
				// 	768: {},
				568: {
					//destroy: true,
				},
			},

		});

		//  Mount the slider
		splide.mount();

		this.sliderObserver(sliderEl, splide);
	}

	sliderFpDelivery() {
		const sliderEl = document.querySelector('#fp-delivery-slider');
		if (!sliderEl) return;
		this.stdSplideSlider(sliderEl);
	}

	sliderFpCarAdvantages() {
		const sliderEl = document.querySelector('#fp-car-advantages-slider');
		if (!sliderEl) return;
		this.stdSplideSlider(sliderEl);
	}

	stdSplideSlider(sliderEl) {
		if (!sliderEl instanceof HTMLElement) return;

		var splide = new Splide(sliderEl, {
			arrowPath: 'M14.2,3.3 C14.9,2.6 16.1,2.6 16.8,3.3 L31.2,17.7 C32.3,18.8 32.3,20.7 31.2,21.8 L16.8,36.2 C16.1,36.9 14.9,36.9 14.2,36.2 C13.5,35.5 13.5,34.3 14.2,33.6 L27.8,20 L14.2,6.4 C13.5,5.7 13.5,4.5 14.2,3.3 Z',
			type: 'loop',
			perPage: 1,
			perMove: 1,
			//autoWidth: true,
			focus: 'center',
			speed: 2000,
			gap: 20,
			arrows: true,
			pagination: true,
			//easing: 'cubic-bezier(0.42, 0, 0.58, 1)', // The "Slow-Fast-Slow" curve
			autoplay: 'pause', // Start in a paused state
			interval: 4000,
			reducedMotion: {
				speed: 2000,
				autoplay: true,
			},
		});

		splide.on('pagination:mounted', function(data) {
			sliderEl.style.setProperty('--slider-pagination-count', data.items.length || 1);
		});

		//  Mount the slider
		splide.mount();

		this.sliderObserver(sliderEl, splide);
	}

	sliderObserver(sliderEl, sliderInstance) {
		// Intersection Observer
		const observer = new IntersectionObserver((entries) => {
			entries.forEach(entry => {
				// Prevent error if Splide is destroyed by the breakpoint
				if (sliderInstance.state.is(6)) return; // 6 is the internal constant for DESTROYED

				const autoplay = sliderInstance.Components.Autoplay;
				if (autoplay) {
					entry.isIntersecting ? autoplay.play() : autoplay.pause();
				}
			});
		}, {threshold: 0.2});

		// Start watching the slider element
		observer.observe(sliderEl);
	}

	scrollTop() {
		const scrollTop = document.querySelector('.scroll-top');
		if (scrollTop != null) {
			const scrollProgressPatch = document.querySelector('.scroll-top path');
			const pathLength = scrollProgressPatch.getTotalLength();
			const offset = 50;
			scrollProgressPatch.style.transition = scrollProgressPatch.style.WebkitTransition = 'none';
			scrollProgressPatch.style.strokeDasharray = pathLength + ' ' + pathLength;
			scrollProgressPatch.style.strokeDashoffset = pathLength;
			scrollProgressPatch.getBoundingClientRect();
			scrollProgressPatch.style.transition = scrollProgressPatch.style.WebkitTransition =
					'stroke-dashoffset 10ms linear';
			window.addEventListener('scroll', function(event) {
				const scroll = document.body.scrollTop || document.documentElement.scrollTop;
				const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
				const progress = pathLength - (scroll * pathLength) / height;
				scrollProgressPatch.style.strokeDashoffset = progress;
				const scrollElementPos = document.body.scrollTop || document.documentElement.scrollTop;
				if (scrollElementPos >= offset) {
					scrollTop.classList.add('progress-done');
				} else {
					scrollTop.classList.remove('progress-done');
				}
			});
			scrollTop.addEventListener('click', function(e) {
				e.preventDefault();
				window.scroll({
					top: 0,
					left: 0,
					behavior: 'smooth',
				});
			});
		}
	}

	/** Check for mobile device **/
	isMobile() {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	}

	stringToBoolean(string) {

		switch (string) {
			case 'true':
			case 'yes':
			case '1':
				return true;
			case 'false':
			case 'no':
			case '0':
			case null:
			case '':
				return false;
			default:
				return Boolean(string);
		}
	}

	/** Check email address **/
	isValidEmailAddress(emailAddress) {
		const pattern = new RegExp(
				/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
		return pattern.test(emailAddress);
	}

// usage: setCookie('visitor_currency', 'USD', {secure: true, 'max-age': 3600});
	setCookie(name, value, options = {}) {

		const defaultPath = window.themeJsVars ?
				(window.themeJsVars.COOKIE_PATH ? window.themeJsVars.COOKIE_PATH : '/')
				: '/';

		const defaultDomain = window.themeJsVars ?
				(window.themeJsVars.COOKIE_DOMAIN ? window.themeJsVars.COOKIE_DOMAIN : '')
				: '';

		options = {
			path: defaultPath,
			domain: defaultDomain,
			...options,
		};

		if (options.expires instanceof Date) {
			options.expires = options.expires.toUTCString();
		}

		let updatedCookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

		for (let optionKey in options) {
			updatedCookie += '; ' + optionKey;
			let optionValue = options[optionKey];
			if (optionValue !== true) {
				updatedCookie += '=' + optionValue;
			}
		}

		document.cookie = updatedCookie;
	}

	getCookie(name) {
		let matches = document.cookie.match(
				new RegExp('(?:^|; )' + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'),
		);
		return matches ? decodeURIComponent(matches[1]) : undefined;
	}

	deleteCookie(name) {
		this.setCookie(name, '', {'max-age': -1});
	}

	getGETParam(paramName) {
		let params = window
		.location
		.search
		.replace('?', '')
		.split('&')
		.reduce(
				function(p, e) {
					var a = e.split('=');
					p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
					return p;
				},
				{},
		);
		return params[paramName];
	}

// example: window.RS.cssRuleUpdate('#menu a[href*="sidebar"]::after','content','"\u2192"','important');
	cssRuleUpdate(selector, property, value, important) {

		let setRuleProperty = function(rule, selector, property, value, important) {
			if (!rule instanceof CSSStyleRule || !rule.selectorText) {
				return false;
			}

			if (rule.selectorText && rule.selectorText == selector) {
				if (typeof important == 'undefined') {
					rule.style.setProperty(property, value);
				} else {
					rule.style.setProperty(property, value, 'important');
				}
				return true;
			}

			return false;
		};

		try {
			for (let i = 0; i < document.styleSheets.length; i++) {
				let ss = document.styleSheets[i];
				let r = ss.cssRules ? ss.cssRules : ss.rules;

				for (let j = 0; j < r.length; j++) {
					if (r[j] instanceof CSSStyleRule) {
						setRuleProperty(r[j], selector, property, value, important);
					}
					if (r[j] instanceof CSSMediaRule && r[j].cssRules) {
						for (let k = 0; k < r[j].cssRules.length; k++) {
							setRuleProperty(r[j].cssRules[k], selector, property, value, important);
						}
					}
				}
			}
		} catch (e) {
			if (e.name !== 'SecurityError') {
				console.log('Developer: ' + e);
			}
		}
	}

}
